import type { CatalogFeature } from "./catalogs/manifest";

export const routeCatalogFeatures = (pathname: string): CatalogFeature[] => {
  if (/^\/(?:home\/?|landing\/?)?$/.test(pathname)) return ["home"];
  if (/^\/seny-i-rauxa\/?$/.test(pathname)) return ["home"];
  if (/^\/careers\/?$/.test(pathname)) return ["home"];
  if (/^\/organize(?:\/|$)/.test(pathname)) return ["home", "race"];
  if (/^\/(?:login|signup|finish-signup|forgot-password)(?:\/|$)/.test(pathname)) return ["auth"];
  if (/^\/(?:legal|accessibility)(?:\/|$)/.test(pathname)) return ["legal"];
  if (/^\/(?:support|contact|contact-corsa)(?:\/|$)/.test(pathname)) return ["support"];
  if (/^\/admin(?:\/|$)/.test(pathname)) return ["admin", "race"];
  if (/^\/settings(?:\/|$)/.test(pathname)) return ["auth", "race"];
  if (/^\/profile(?:\/|$)/.test(pathname)) return ["auth", "race"];
  if (/^\/account(?:\/|$)/.test(pathname)) return ["auth"];
  return ["race"];
};
